import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted fonts — bundled into the build so the app is fully styled offline
// and inside the Android WebView (no runtime call to fonts.googleapis.com).
import '@fontsource/dm-sans/latin-400.css';
import '@fontsource/dm-sans/latin-500.css';
import '@fontsource/dm-sans/latin-600.css';
import '@fontsource/playfair-display/latin-700.css';
import '@fontsource/playfair-display/latin-900.css';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { isNativeApp, hideSplash } from './native';

// Native-only: mark the document so app-like CSS (no text selection / callout)
// applies inside the Capacitor WebView but never on the deployed web PWA. Also
// arm a splash backstop that survives even if <App/> never mounts.
if (isNativeApp()) {
  document.documentElement.classList.add('native');
  setTimeout(hideSplash, 5000);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline support
serviceWorkerRegistration.register();
